// index.less 必须放置在 import 的 第一个
import './index.less';
import React from 'react';
import BaseLayout from '@src/components/pc-layout';
import RouteEnhance from '@src/components/route/route-enhance';
import routeConfigs from '@src/pages/app-router/route-configs';
import RouteSwitchEnhance from '@src/components/route/route-switch-enhance';
import { HashRouter as Router } from 'react-router-dom';
import { $$tracker } from '@src/tracker';

export default class AppRouter extends React.PureComponent {
  componentDidMount() {
    const areacode = document.documentElement.lang;
    // console.log('data.data.areacode', areacode);
    $$tracker.pageLoadDuration(areacode);
  }

  render() {
    return (
      <Router>
        <BaseLayout>
          <RouteSwitchEnhance>{Object.keys(routeConfigs).map(key => <RouteEnhance key={key} {...routeConfigs[key]} />)}</RouteSwitchEnhance>
        </BaseLayout>
      </Router>
    );
  }
}
